


















import ProfessionIndex from '@/views/system/organization/profession/unit/index.vue';
import ProfessionEdit from '@/views/system/organization/profession/unit/edit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { ProfessionIndex, ProfessionEdit },
})
export default class Profession extends Vue {
  flag = 1; // 控制显示主页组件还是编辑和新增组件,1：index页面 2：编辑页面 3：新增页面
  row = ''; // index组件向编辑组件传值
}
